import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-add\"><path d=\"M512 0a73.142857 73.142857 0 0 1 73.142857 73.142857v365.714286h365.714286a73.142857 73.142857 0 0 1 0 146.285714H585.142857v365.714286a73.142857 73.142857 0 0 1-146.285714 0V585.142857H73.142857a73.142857 73.142857 0 1 1 0-146.285714h365.714286V73.142857a73.142857 73.142857 0 0 1 73.142857-73.142857z\" p-id=\"1156\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol